import { useEffect, useState } from "react";
import Hero from "../sections/Hero";
import Apertura from "../sections/Apertura";
import Metodo from "../sections/Metodo";
import Servizi from "../sections/Servizi";
import Patto from "../sections/Patto";
import Bottega from "../sections/Bottega";
import Casi from "../sections/Casi";
import Quaderni from "../sections/Quaderni";
import ComeSiComincia, { Chiusura } from "../sections/ComeSiComincia";
import MarqueeBand from "../components/Marquee";

// le sezioni sotto la piega si montano appena il primo frame è disegnato
const useAfterFirstPaint = () => {
    const [ready, setReady] = useState(false);
    useEffect(() => {
        const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));
        const id = idle(() => setReady(true), { timeout: 300 });
        return () => (window.cancelIdleCallback || clearTimeout)(id);
    }, []);
    return ready;
};

export default function Home() {
    const rest = useAfterFirstPaint();
    return (
        <main data-testid="home-page">
            <Hero />
            <Apertura />
            {rest && (
                <>
                    <MarqueeBand />
                    <Casi />
                    <ComeSiComincia />
                    <Metodo />
                    <Servizi />
                    <Bottega />
                    <Patto />
                    <Quaderni />
                    <Chiusura />
                </>
            )}
        </main>
    );
}
